
/* eslint-disable */
import Vue from 'vue'
import Component from 'vue-class-component'

interface SimpleArtist {
    id: string;
    name: string;
    image: string;
}

@Component
export default class ArtistsList extends Vue {
    loader = true
    pageOffset = 0
    pageOffsetAlt = 0
    clicks = 1
    pageOffsetMonth = 0
    pageOffsetAltMonth = 0
    clicksMonth = 1
    view = 'total'
    error: any = null
    sourceArtists: SimpleArtist[] = []

    get radioSource() {
        return this.$store.getters['getRadioSource']
    }

    get isExternalSource() {
        return this.radioSource === 'audius' || this.radioSource === 'suno'
    }

    get artistTotal () {
        if (this.isExternalSource) return this.sourceArtists
        return this.$store.getters['artistModule/getArtistsTotal']
    }

    get artistMonth () {
        if (this.isExternalSource) return this.sourceArtists
        return this.$store.getters['artistModule/getArtistsMonth']
    }

    coverStyle(image?: string, name?: string) {
        if (image && image.trim() && image.indexOf('url("")') === -1) {
            return { backgroundImage: `var(--hero-overlay), url(${image})` }
        }
        const str = name || 'fallback';
        let hash = 0;
        for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
        const hue = Math.abs(hash) % 360;
        return {
            backgroundImage: `linear-gradient(135deg, hsl(${hue}, 70%, 20%), hsl(${(hue + 40) % 360}, 80%, 15%))`
        }
    }

    pageNext () {
        if (this.isExternalSource) return
        this.pageOffset += 16
        this.loader = true
        this.$store.dispatch('artistModule/fetchPagesForTopArtists', this.pageOffset).then(()=> {
            this.loader = false
            window.scrollTo(0,0);
            this.clicks ++;
            this.pageOffsetAlt += 16
        })
    }
    pageBack () {
        if (this.isExternalSource) return
        this.loader = true
        this.pageOffset -= 16
        this.$store.dispatch('artistModule/fetchPagesForTopArtists', this.pageOffset).then(() => {
            this.loader = false
            window.scrollTo(0,0);
            this.clicks --;
            this.pageOffsetAlt -= 16
        })
    }

    pageNextMonth () {
        if (this.isExternalSource) return
        this.loader = true
        this.pageOffsetMonth += 16
        this.$store.dispatch('artistModule/fetchPagesForTopArtistsMonth', this.pageOffsetMonth).then(()=> {
            this.loader = false
            window.scrollTo(0,0);
            this.clicksMonth ++;
            this.pageOffsetAltMonth += 16
        })
    }
    pageBackMonth () {
        if (this.isExternalSource) return
        this.loader = true
        this.pageOffsetMonth -= 16
        this.$store.dispatch('artistModule/fetchPagesForTopArtistsMonth', this.pageOffsetMonth).then(() => {
            this.loader = false
            window.scrollTo(0,0);
            this.clicksMonth --;
            this.pageOffsetAltMonth -= 16
        })
    }

    async loadContent() {
        this.loader = true
        window.scrollTo(0,0);
        if (this.isExternalSource) {
            const module = this.radioSource === 'suno' ? 'sunoModule/fetchRadioTracks' : 'audiusModule/fetchRadioTracks'
            const tracks = await this.$store.dispatch(module, { limit: 50 })
            const seen = new Set<string>()
            this.sourceArtists = []
            for (const t of tracks) {
                if (!seen.has(t.artist_id)) {
                    seen.add(t.artist_id)
                    this.sourceArtists.push({
                        id: t.artist_id,
                        name: t.artist_name,
                        image: t.image || ''
                    })
                }
            }
            this.loader = false
        } else {
            this.$store.dispatch('artistModule/fetchTopArtists').then(() => {
                this.loader = false
            }).catch((error: any) => {
                this.loader = false
                this.error = error
            })
            this.$store.dispatch('artistModule/fetchTopArtistsMonth')
        }
    }

    mounted() {
        this.loadContent()
        this.$store.watch(
            (state: any) => state.radioSource,
            () => { this.loadContent() }
        )
    }
}
